import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SessionService } from '@core/session.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-toggle-slider',
  templateUrl: './toggle-slider.component.html',
  imports: [CommonModule, TranslateModule],
})
export class ToggleSliderComponent {
  @Input() status = false;
  @Input() shouldRequiredLogin = false;
  @Input() settings: {
    disabled?: boolean;
    activeText: string;
    activeClass?: string;
    deactiveText: string;
    activeIcon?: string;
    deactiveIcon?: string;
  };

  constructor(private readonly sessionService: SessionService) {}

  @Output() statusChange = new EventEmitter<boolean>();

  toggle(active = null): void {
    if (
      (this.shouldRequiredLogin &&
        this.sessionService.authenticated &&
        this.sessionService.isTokenExpired()) ||
      this.settings?.disabled
    ) {
      return;
    }
    this.status = active ?? !this.status;
    this.statusChange.emit(this.status);
  }
}
